import React from "react";
import HeroImage from "../assets/hero.svg";



const Hero = () => {
  return (
    <div className="w-full h-100 my-20 lg:my-20 flex justify-evenly place-content-center">
      {/* <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                   <Spring
                   delay={100}
                   to={{
                     transform: isVisible
                       ? "translateY(0)"
                       : "translateY(0%)",
                   }}
                 >
                   {(props) => (
                  <div style={{...props}}> */}
      <div className="px-5">
        <h1 className="dark-blue text-2xl lg:text-4xl my-5 font-semib fontR">
          Hi, I’m Faruk Alade.
        </h1>
        <h1 className="dark-blue text-4xl lg:text-6xl font-semibold fontR">
          I transform ideas <br className="lg:hidden" /> and designs
          <br className="hidden lg:block" /> into{" "}
          <span style={{ color: "#0077CC" }}>scalable</span> and{" "}
          <span style={{ color: "#0077CC" }}>reusable</span>
          <br /> code.
        </h1>
        <p className=" dark-blue text-md  fontN my-5 mb-10">
          I am a Frontend Web Developer, adept at creating dynamic and
          responsive user interfaces . My commitment to clean code and
          <br className="hidden lg:block" /> user-centric design drives me to
          consistently deliver impactful high-performance web applications that
          resonate with users
        </p>

        <div className="flex flex-wrap w-full fontN">
          <a
            href="mailto:alade.faruk11@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="py-3 my-2 w-full lg:w-2/6 text-white text-center dark-bg rounded-lg cursor-pointer "
          >
            Say hello
          </a>

          <a
            href="https://drive.google.com/file/d/1100NRYV_hYVVdyLvo2Elal3UBo26axoL/view?usp=sharing"
            target="_blank"
            className="py-3 my-2 w-full text-center lg:w-2/6 rounded-lg light-bg dark-blue lg:mx-6 cursor-pointer"
          >
            View My Resume
          </a>
        </div>
      </div>

      <img alt="Hero" src={HeroImage} className="hidden lg:block" />

      {/* </div>)}</Spring>
                )}
                
                </VisibilitySensor> */}
    </div>
  );
};

export default Hero;
